<template>
	<div style="width: 100%" class="menuBody">
		<el-container style="background: #fff; width: 100%">
			<el-aside style="width: 240px; padding-left: 20px; padding-top: 20px">
				<left-floor-tree @chooseNode="selectNode"></left-floor-tree>
			</el-aside>
			<el-main style="padding-left: 0px; padding-top: 20px">
				<el-tabs v-model="currentTab" type="border-card" style="width:100%;float:left;">
					<el-tab-pane v-if="show('hydropower.web.meter.basic.listPage')" name="basic" label="基础信息列表"><MeterBasic :parentData="currentTreeNodeData" v-if="currentTab == 'basic'"></MeterBasic></el-tab-pane>
					<el-tab-pane v-if="show('hydropower.web.basic.handwork.listPage')" name="handwork" label="手抄列表"><MeterHandWork :parentData="currentTreeNodeData" v-if="currentTab == 'handwork'"></MeterHandWork></el-tab-pane>
					<!-- <el-tab-pane name="deduction" label="收费调整列表"><MeterDeduction v-if="currentTab == 'deduction'" ></MeterDeduction></el-tab-pane> -->
				</el-tabs>
			</el-main>
		</el-container>
	</div>
</template>
<script>
import MeterBasic from "./MeterBasic.vue";
import MeterHandWork from "./MeterHandWork.vue";
import MeterDeduction from "./MeterDeduction.vue";
import LeftFloorTree from "@/components/LeftFloorTree.vue";
import {Juris} from "@/directives/Juris";
export default {
	name: "MeterBasicIndex",
	components: { MeterBasic, MeterHandWork, MeterDeduction, LeftFloorTree },
	data() {
		return {
			currentTab: "basic",
			currentTreeNodeData: {},
		};
	},
	methods: {
		selectNode(data) {
			this.currentTreeNodeData = data;
		},
        show(permitFlag) {
            return Juris(permitFlag);
        }
	},
	mounted() {},
};
</script>
<style scoped>
.menuBody >>> .el-tabs__nav-scroll {
    background: #fff;
    border-top: 0px solid #E4E7ED;
}
</style>
